import React from 'react'

import { useRouteContext } from 'plugin-channelmanager/hooks/useRouteContext'

import { Scrollbars } from '../generic'
import { useDimensions } from '../hooks'
import { ChannelsList } from './components/ChannelsList/ChannelsList'
import { SettingsContainer } from './styles'

export const ChannelsSettings: React.FC = () => {
    const { params } = useRouteContext()
    const dimensions = useDimensions()

    return (
        <SettingsContainer>
            {params.type === 'list' && (
                <>
                    <Scrollbars height={dimensions.height} className="settings-lists-wrapper">
                        <div className="container settings-lists">
                            <ChannelsList />
                        </div>
                    </Scrollbars>
                </>
            )}
        </SettingsContainer>
    )
}
